export const environment = {
  "production": true,
  "cognito": {
    "region": "us-east-2",
    "userPoolId": "us-east-2_lsCnoUpbG",
    "userPoolClientId": "1ecle2fuipkt2s10rbkudu34qj"
  },
  "api_url": "https://api.app.saas.currentware.com/customer-management/api",
  "mockApi": false,
  "portalDomain": "app.saas.currentware.com",
  "portalSubdomainPrefix": "cmp",
  "showNewFeatures": false,
  "googleAnalyticsId": "G-VPGT9P1Q5F",
  "features": {
    "agentUpload": true,
    "scheduler": false
  },
  "hubspot": {
    "baseUrl": "https://www.currentware.com/api",
    "apiKey": "key_kEDWLb4aVegaBOUhOVIvyWUrOeRGejVeqEcMyKGXHBNnNAby0B0eSbhtjO82osd6"
  }
};
